import ListTableColumnTag from '@/views/smart-name-card/name-card-decoration/components/decoration-config/components/list-table-column-tag/index.vue'
import ListTableColumnCarouselPicture from '@/views/smart-name-card/name-card-decoration/components/decoration-config/components/list-table-column-carousel-picture'

import TableRadio from './table-radio'
// table-radio
export default {
  materials: {
    title: '营销资料',
    icon: {
      show: false,
      message: '名片不支持添加任意链接转载文章'
    },
    name: 'materials',
    component: '',
    showButton: true,
    mode: 'table',
    form: {
      // radio: {
      //   label: '资料类型',
      //   show: false,
      //   data: [{
      //     label: '文章',
      //     name: 'article'
      //   }, {
      //     label: 'H5',
      //     name: 'h5'
      //   }, {
      //     label: '表单',
      //     name: 'form'
      //   }]
      // },
      // 分类多级选择
      radioGroup: {
        label: '资料类型',
        show: true,
        data: [
          {
            label: '营销资料',
            name: 'material',
            children: [
              {
                label: '文章',
                name: 'article'
              },
              {
                label: 'H5',
                name: 'h5'
              },
              {
                label: '表单',
                name: 'form'
              }
            ]
          },
          {
            label: '宣传册',
            name: 'brochure'
          },
          {
            label: '视频',
            name: 'video'
          }
        ]
      },
      tags: {
        show: true,
        data: []
      },
      input: {
        show: true,
        placeholder: '请输入标题'
      }
    },
    list: {
      type: 'Table', // or Image
      columns: [{
        prop: '',
        label: '',
        width: '40px',
        // 自定义组件-单选框
        component: TableRadio
      }, {
        prop: 'title',
        label: '标题',
        // 自定义组件
        component: null
      }, {
        prop: 'tags',
        label: '标签',
        // 自定义组件
        component: ListTableColumnTag
      }, {
        prop: 'updateTime',
        label: '更新时间',
        width: '180px',

        // 自定义组件
        component: null
      }]
    },
    params: {
      type: 'article'
    },
    // 数量限制
    limit: 6
  },
  goods: {
    title: '商品',
    name: 'goods',
    icon: {
      show: false,
      message: ''
    },
    mode: 'table',
    component: '',
    showButton: true,
    form: {
      input: {
        show: true,
        placeholder: '请输入标题'
      }
    },
    list: {
      type: 'Table', // or Image
      columns: [{
        prop: '',
        label: '',
        width: '40px',
        // 自定义组件-单选框
        component: TableRadio
      }, {
        prop: 'carouselPicture',
        label: '商品主图',
        // 自定义组件
        component: ListTableColumnCarouselPicture
      }, {
        prop: 'name',
        label: '商品名称',
        // 自定义组件
        component: null
      }, {
        prop: 'desc',
        label: '描述',
        // 自定义组件
        component: null
      }]
    },
    limit: 9,
    params: {
      type: 'good'
    }
  }
}
